/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'building/hab_open_poor': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M16.4 22c1.051-.262 1.6-1 1.6-2s-1-2-2-2-2 1-2 2 .582 1.738 1.6 2c-.6 0-1.6 1-1.6 3v3h4v-3c0-2-1-3-1.6-3zM22.4 22c1.051-.262 1.6-1 1.6-2s-1-2-2-2-2 1-2 2 .582 1.738 1.6 2c-.6 0-1.6 1-1.6 3v3h4v-3c0-2-1-3-1.6-3zM10.4 22c1.051-.262 1.6-1 1.6-2s-1-2-2-2-2 1-2 2 .582 1.738 1.6 2C9 22 8 23 8 25v3h4v-3c0-2-1-3-1.6-3zM7 13h18v2H7zM4.5 32H0v-4.5h1V31h3.5zM32 32h-4.5v-1H31v-3.5h1zM32 4.5h-1V1h-3.5V0H32zM1 4.5H0V0h4.5v1H1z"/>'
  }
})
